import DashboardLayout from '../layouts/DashboardLayout'
// import ProductList from '../pages/products/product/ProductList'
// import ProductForm from '../pages/products/product/components/ProductForm'
// import ProductGroupList from '../pages/products/product-group/ProductGroupList'
// import ComboList from '../pages/products/combo/ComboList'

export const productMenu = {
  path: '/products',
  component: DashboardLayout,
  name: 'Products',
  redirect: '/products',
  roles: ['product_read','product_create','product_update','product_delete'],
  children: [
    {
      path: 'product-list',
      name: 'ProductList',
      component: () => import (/* webpackChunkName: "about" */'../pages/products/product/ProductList.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [{
          title: 'Danh sách sản phẩm',
        }],
        roles: ['product_read','product_create','product_update','product_delete'],
      },
    },
    {
      path: '/products/product-list/edit/:id',
      name: 'EditProduct',
      component: () => import (/* webpackChunkName: "about" */'../pages/products/product/components/ProductForm.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [{
          title: 'Danh sách sản phẩm',
          to: '/products/product-list',
        }, {
          title: 'Chỉnh sửa sản phẩm',
          to: '',
        }],
        roles: ['product_update'],
      },
    },
    {
      path: 'create-product',
      name: 'CreateProduct',
      component: () => import (/* webpackChunkName: "about" */'../pages/products/product/components/ProductForm.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [{
          title: 'Danh sách sản phẩm',
          to: '/products/product-list',
        }, {
          title: 'Tạo sản phẩm',
          to: '',
        }],
        roles: ['product_create'],
      },
    },
    {
      path: 'product-group-list',
      name: 'ProductGroupList',
      component: () => import (/* webpackChunkName: "about" */'../pages/products/product-group/ProductGroupList.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [{
          title: 'Danh sách nhóm sản phẩm'
        }],
        roles: ['product_group_read','product_group_create','product_group_update','product_group_delete'],
      },
    },
    {
      path: 'combo-list',
      name: 'ComboList',
      component: () => import (/* webpackChunkName: "about" */'../pages/products/combo/ComboList.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [{
          title: 'Combo Sản Phẩm',
          to: '',
        }],
        roles: ['combo_read','combo_create','combo_update','combo_delete'],
      },
    },
  ],
}